module.exports = "/static/assets/064fcba3fb7ff24397f9247e7365bae5.gif";